import { render, staticRenderFns } from "./TopSellingArticles.vue?vue&type=template&id=237d70e5"
import script from "./TopSellingArticles.vue?vue&type=script&lang=js"
export * from "./TopSellingArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports